import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import React from 'react';

const MICROSOFT_PROVIDER = {
  id: 'microsoft-auth-provider',
  title: 'Microsoft',
  message: 'Sign in with your company account (Entra ID)',
  apiRef: microsoftAuthApiRef,
};

function AppSignInPage(props: Parameters<typeof SignInPage>[0]) {
  return React.createElement(SignInPage, {
    ...props,
    provider: MICROSOFT_PROVIDER,
  });
}

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => AppSignInPage as React.ComponentType<any>,
      },
    }),
  ],
});
